import React, { Component } from 'react';

class PageManual extends Component {
  constructor(){
    super();
    document.title = "使用指南";
  }
  render() {
    //history 没用context 等16.7版本
    return (
      <div className="robotchat-manual-ui" id="robotchat-manual-ui">
        <img src="//pic1.58cdn.com.cn/nowater/cxnomark/n_v2f7fa50cbe41f4a94bde898fa24b85a05.png" alt="啊哦 图片显示失败了 试试回去与小助手对话看看" width="100%"></img>
      </div>
    );
  }
}

export default PageManual;


